<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <g clip-path="url(#paper-icon)">
        <path
          fill="inherit"
          stroke="none"
          d="m0 13.5 2.6 1.12L9 17.36V23.25l2.25.75 3.44-4.2 4.16 1.78 2.15.92.3-2.32 2.33-17.4L24 0l-2.46 1.38L2.47 12.1 0 13.5Zm19.16 5.77-6.58-2.83 8.27-9.87-1.69 12.7Zm-8.74-3.75-5.34-2.3L18.82 5.5l-8.4 10.03Z"
        />
      </g>
      <defs>
        <clipPath id="paper-icon"><path fill="inherit" stroke="none" d="M0 0h24v24H0z" /></clipPath>
      </defs>
    </svg>
  </span>
</template>
